import { render } from "./AddCeibaServer.vue?vue&type=template&id=0f5caa00"
import script from "./AddCeibaServer.vue?vue&type=script&lang=js"
export * from "./AddCeibaServer.vue?vue&type=script&lang=js"
script.render = render

export default script